// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseListModuleRequestData } from './genericApiResponseListModuleRequestData';
import type { GenericApiResponseListModuleRequestMessage } from './genericApiResponseListModuleRequestMessage';
import type { GenericApiResponseListModuleRequestPagination } from './genericApiResponseListModuleRequestPagination';
import type { GenericApiResponseListModuleRequestError } from './genericApiResponseListModuleRequestError';

export interface GenericApiResponseListModuleRequest {
  data?: GenericApiResponseListModuleRequestData;
  message?: GenericApiResponseListModuleRequestMessage;
  pagination?: GenericApiResponseListModuleRequestPagination;
  error?: GenericApiResponseListModuleRequestError;
  statusCode?: number;
}
